import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { LoggerService } from '@timechef/core/logging';

@Injectable()
export class ErrorHandlerService extends ErrorHandler {
  constructor(private injector: Injector) {
    super();
  }

  handleError(error: Error) {
    this.injector.get(LoggerService).getLogger('ErrorHandlerService').error(error.message, error); // Manually log exception
  }
}
